import IcSearch from './IcSearch'

export default IcSearch
